module.exports = __webpack_public_path__ + "static/media/experience@3x.0939d9ac.png";